import { useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { CiEdit, CiTrash } from 'react-icons/ci';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { TbError404 } from 'react-icons/tb';
import Swal from 'sweetalert2';

const PromoProductTable = ({ promoProductTables, onEdit, loading, updateOnActive, onDelete }) => {

    const [selectedRows, setSelectedRows] = useState(false);
    const [toggledClearRows, setToggleClearRows] = useState(false);

    const handleChange = ({ selectedRows }) => {
        setSelectedRows(selectedRows);
    };

    // Toggle the state so React Data Table changes to clearSelectedRows are triggered
    const handleClearRows = () => {
        setToggleClearRows(!toggledClearRows);
    }

    const handleToggleStatus = async (row) => {
        Swal.fire({
            title: "Are you sure?",
            text: `Do you want to change status to ${row.active === 1 ? "Inactive" : "Active"}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, update it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const updatedStatus = row.active == 1 ? 0 : 1;
                    console.log('form table ', row.id, updatedStatus)
                    updateOnActive(row.id, { id: row.id, active: updatedStatus })
                    Swal.fire("Updated!", "Status has been updated.", "success");
                } catch (error) {
                    console.error("Failed to update status", error);
                    Swal.fire("Error!", "Failed to update status.", "error");
                }
            }
        });
    };

    const columns = [
        {
            name: 'No.',  // Serial Number Column
            selector: (row, index) => index + 1,
            sortable: true,
            width: '60px',  // Optional: Adjusts the width
        },
        { name: 'Code Promo', selector: row => row.code_promo, sortable: true },
        { name: 'Name', selector: row => row.name, sortable: true },
        {
            name: 'Type Promo', selector: row => (
                <span
                    style={{
                        cursor: 'pointer',
                        color: row.type_promo == 1 ? 'green' : 'blue',
                        border: '1px solid',  // Adds a border
                        borderColor: row.type_promo == 1 ? 'green' : 'blue', // Dynamic border color
                        padding: '5px 10px', // Adds spacing inside the border
                        borderRadius: '5px', // Rounded corners
                        display: 'inline-flex', // Aligns icon and text properly
                        alignItems: 'center', // Centers content vertically
                        gap: '5px' // Space between icon and text
                    }}
                    onClick={() => handleToggleStatus(row)}
                >
                    {row.type_promo == 1 ? <FaCheckCircle /> : <FaCheckCircle />} {row.type_promo == 1 ? 'Hospital' : 'Product'}
                </span>
            ), sortable: true
        },
        { name: 'Discount', selector: row => row.discount, sortable: true },
        {
            name: 'Image', selector: row => (
                row.image ?
                    <>
                        <img
                            src={row.image} // Replace with your image field
                            // alt={row.name} // Add an alt attribute for accessibility
                            style={{ width: '30px', height: '30px', objectFit: 'cover', borderRadius: '4px' }} // Styling
                        />
                    </> : <TbError404 size={25} />
            ),
        },
        {
            name: 'Active',
            cell: row => (
                <span
                    style={{ cursor: 'pointer', color: row.active === 1 ? 'green' : 'red' }}
                    onClick={() => handleToggleStatus(row)}
                >
                    {row.active === 1 ? <FaCheckCircle /> : <FaTimesCircle />} {row.active === 1 ? 'Active' : 'Inactive'}
                </span>
            ),
            sortable: true,
        },
        {
            name: 'Actions',
            cell: row => (
                <div style={{ display: "flex", justifyContent: "center", gap: "5px" }}>
                    <Button variant="outline-warning" size="sm" onClick={() => onEdit(row)}>
                        <CiEdit size={16} />
                    </Button>
                    <Button variant="outline-danger" size="sm" onClick={() => onDelete(row)}>
                        <CiTrash size={16} />
                    </Button>
                </div>
            ),
            center: true, // Ensures alignment within DataTable
            width: "150px", // Adjust width if needed
        },
    ];


    const customStyles = {
        headCells: {
            style: {
                fontSize: "14px", // Adjust header font size
                fontWeight: "bold",
            },
        },
        cells: {
            style: {
                fontSize: "12px", // Adjust cell font size
                padding: "0px",
                margin: "0px"
            },
        },
        rows: {
            style: {
                minHeight: "35px", // Minimum row height
                maxHeight: "35px", // Maximum row height (optional)
            },
        },
    };

    return (
        <>
            {selectedRows.length > 0 && (
                <button onClick={handleClearRows}>Clear Selected Rows</button>
            )}
            <Card>
                <Card.Body>
                    <DataTable
                        title="Promo Products"
                        columns={columns}
                        data={promoProductTables}
                        pagination
                        responsive
                        highlightOnHover
                        customStyles={customStyles}
                        defaultSortFieldId={1} />
                </Card.Body>
            </Card>
        </>
    )
};

export default PromoProductTable;